import { checkCookie, clearAllCookies } from '../utils/cookie.js';

const handleLoginRedirect = () => {
  const cookieNameArray = ['AnalyticsData', 'WorkflowSummeryData'];
  const authenticated = cookieNameArray.every((name) => checkCookie(name));

  if (authenticated && document.location.pathname === '/') {
    globalThis.location.replace('/workflows');
  }

  if (!authenticated && document.location.pathname !== '/') {
    globalThis.location.replace('/');
  }
};

const handleLogout = (event) => {
  event.preventDefault();

  const element = event.target.closest('a');
  const path = element?.getAttribute('href');
  if (path) {
    clearAllCookies();
    setTimeout(() => {
      globalThis.location.href = element.href;
      globalThis.history.replaceState({}, document.title, element.href);
      globalThis.location.reload(true);
    }, 0);
  }
};

(() => {
  globalThis.addEventListener('DOMContentLoaded', handleLoginRedirect);
  globalThis.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      globalThis.location.reload();
    }
  });
  const logout = document.querySelector('#logout-icon');
  if (logout) {
    logout.addEventListener('click', handleLogout, true);
  }
})();
